export default function LinkedInIcon() {
  return (
    <svg
      fill="none"
      height="14"
      viewBox="0 0 14 14"
      width="14"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_952_654)">
        <path
          d="M13.9918 13.9928V8.87035C13.9918 6.35281 13.4498 4.42969 10.5127 4.42969C9.09658 4.42969 8.1525 5.19894 7.76788 5.93322H7.73291V4.65697H4.95312V13.9928H7.85529V9.35987C7.85529 8.13607 8.08257 6.96471 9.5861 6.96471C11.0722 6.96471 11.0896 8.34586 11.0896 9.42981V13.9754H13.9918V13.9928Z"
          fill="#F0F3F9"
        />
        <path
          d="M0.233398 4.65723H3.13556V13.9931H0.233398V4.65723Z"
          fill="#F0F3F9"
        />
        <path
          d="M1.68422 0.00585938C0.757625 0.00585938 0.00585938 0.757625 0.00585938 1.68422C0.00585938 2.61082 0.757625 3.38006 1.68422 3.38006C2.61082 3.38006 3.36258 2.61082 3.36258 1.68422C3.36258 0.757625 2.61082 0.00585938 1.68422 0.00585938Z"
          fill="#F0F3F9"
        />
      </g>
      <defs>
        <clipPath id="clip0_952_654">
          <rect fill="white" height="14" width="14" />
        </clipPath>
      </defs>
    </svg>
  );
}
